import { useSemaforoAsignacion } from "../../../hooks/useAsistenciasSemaforo";

export const useGetAsignaciones = () => {
  const { asistencias, loading, error } = useSemaforoAsignacion();
  return { asignaciones: asistencias, loading, error };
};
